// extracted by mini-css-extract-plugin
module.exports = {"average_earnings_card":"JZWIT_Content_average_earnings_card__3uoXc","related_list":"JZWIT_Content_related_list__1xok3","related_card":"JZWIT_Content_related_card__1IWmI"};